import hyphen from 'hyphen'
import pattern from 'hyphen/patterns/en-us.js'
import { isNil } from 'lodash'

const SOFT_HYPHEN = '\u00ad'
const hyphenator = hyphen(pattern)

const splitHyphen: (word: string) => string[] = (word) => {
  return word.split(SOFT_HYPHEN)
}

const cache: Record<string, string[]> = {}

const getParts: (word: string) => string[] = (word) => {
  const base = word.includes(SOFT_HYPHEN) ? word : hyphenator(word)
  return splitHyphen(base)
}

const wordHyphenation = () => {
  return (word: string | null) => {
    const cacheKey = isNil(word) ? '' : `_${word}`

    if (isNil(word)) return []
    if (!isNil(cache[cacheKey])) return cache[cacheKey]

    cache[cacheKey] = getParts(word)

    return cache[cacheKey]
  }
}

// ✅ Export a defaultHyphenCb compatible with React-PDF
const defaultHyphenCb: (word: string, _glyphString?: object) => string[] = (
  word,
  _glyphString
) => {
  const hyphenFn = wordHyphenation()
  return hyphenFn(word)
}

export default defaultHyphenCb
